<ng-container *ngIf="isEditable || imageUrl">
  <div
    class="subheader-block show-hover-parent"
    [style.background-image]="backgroundImageUrl ? backgroundImageUrl : ''"
    [style.height]="height"
  >
    <div class="block-edit show-hover-child" *ngIf="isEditable">
      <arsultima-ui-button-edit-contextual
        (click)="!!id ? editSlide() : addSlide()"
        class="show-hover-child"
        [tooltip]="buttonTooltip"
      ></arsultima-ui-button-edit-contextual>
    </div>
    <div class="image-copyright">
      <span>{{ copyright }}</span>
    </div>
  </div>
</ng-container>
